import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [adminData, setAdminData] = useState(null);
  const [adminDataLoading, setAdminDataLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = Cookies.get('enervybe:sess');
    if (storedToken) {
      setToken(storedToken);
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const fetchAdminData = async () => {
    setAdminDataLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Signature: `${process.env.REACT_APP_API_SIGNATURE}`
        }
      })
      if (response.status === 200) {
        setAdminData(response.data)
        setAdminDataLoading(false);
      }
    } catch (error) {
      setAdminDataLoading(false);
      logout();
      console.error('Error fetching admin data:', error)
    }
  }
  
  useEffect(() => {
    if (token) {
      fetchAdminData()
    }
  }, [token])

  const login = (newToken, rememberMe) => {
    setToken(newToken);
    setIsAuthenticated(true);
    const expires = rememberMe ? 30 : 7; // Days
    Cookies.set('enervybe:sess', newToken);
  };

  const logout = () => {
    setToken(null);
    setIsAuthenticated(false);
    Cookies.remove('enervybe:sess');
    navigate('/login');
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, token, login, logout, loading, adminData, fetchAdminData }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

// Custom hook for handling login and navigation
export const useLoginNavigation = () => {
  const { login } = useAuth();
  const [isLoginComplete, setIsLoginComplete] = useState(false);

  const handleLogin = (token, rememberMe) => {
    login(token, rememberMe);
    setIsLoginComplete(true);
  };

  return { handleLogin, isLoginComplete };
};